module.exports = __webpack_public_path__ + "Server-Disabled.TentaclePassive.fcdd5005d2db66310452c55ad3159231.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Disabled.TentaclePassive.png
// module id = 7310671695294368
// module chunks = 1